export default class DayPartsApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getDayParts(params, httpConfig) {
    return this.httpGet('day_parts', params, httpConfig);
  }

  createDayPart(dayPart, params, httpConfig) {
    return this.httpPost('day_parts', dayPart, params, httpConfig);
  }

  updateDayPart(dayPart, params, httpConfig) {
    return this.httpPut(`day_parts/${dayPart.id}`, dayPart, params, httpConfig);
  }

  deleteDayPart(dayPartId, params, httpConfig) {
    return this.httpDelete(`day_parts/${dayPartId}`, params, httpConfig);
  }

  dayPartsBulk(dayParts, params, httpConfig) {
    return this.httpPut('day_parts/bulk', dayParts, params, httpConfig);
  }
}
